import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export const DocumentViewer = ({ doc, onClose }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!doc) return;
    let objectUrl;
    api.get(`/documents/${doc.id}/download`, { responseType: "blob" })
      .then((r) => { objectUrl = URL.createObjectURL(r.data); setUrl(objectUrl); })
      .catch(() => setError("Unable to load document"));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); setUrl(null); setError(""); };
  }, [doc]);

  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl h-[85vh] flex flex-col" data-testid="document-viewer">
        <DialogHeader>
          <DialogTitle className="font-display">{doc?.document_type} · {doc?.original_filename}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 rounded-lg bg-slate-100 flex items-center justify-center overflow-hidden">
          {error ? (
            <p className="text-sm text-red-500" data-testid="document-viewer-error">{error}</p>
          ) : !url ? (
            <Loader2 className="h-8 w-8 text-[#FF6B00] animate-spin" />
          ) : doc.content_type === "application/pdf" ? (
            <iframe title="document" src={url} className="w-full h-full" data-testid="document-viewer-pdf" />
          ) : (
            <img src={url} alt={doc.original_filename} className="max-h-full max-w-full object-contain" data-testid="document-viewer-image" />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
